import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { PropsWithChildren } from 'react';

interface Props {
    isOpen: boolean;
    handleClose: (
        e: React.MouseEvent<HTMLElement>,
        reason?: 'backdropClick' | 'escapeKeyDown',
    ) => void;
    title?: string;
}

function Modal({ children, isOpen, handleClose, title }: PropsWithChildren<Props>) {
    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="md" disableEscapeKeyDown={true}>
            <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end', marginRight: 0 }}>
                <CloseIcon />
            </IconButton>
            {title ? <DialogTitle marginLeft={3}>{title}</DialogTitle> : null}
            <DialogContent>{children}</DialogContent>
        </Dialog>
    );
}

export default Modal;
